"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassesDropDown = void 0;
const react_1 = __importStar(require("react"));
const common_1 = require("../../../common");
const classes_1 = require("../../../server/classes");
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const react_redux_1 = require("react-redux");
const account_1 = require("../account");
const Colors_1 = require("../../../Colors");
exports.ClassesDropDown = react_1.default.memo(({ userId, userTenantId, defaultClasses, setClasses, setTenantId, }) => {
    const { isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const isManager = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsManager)(state));
    const [dropValue, setDropValue] = react_1.default.useState({ id: 'select', title: 'common.select' });
    const [dropList, setDropList] = react_1.default.useState([]);
    const [dropDownItems, setDropDownItems] = react_1.default.useState([]);
    const { data, refetch } = (0, classes_1.useClassesList)(!isManager && userId
        ? {
            belong_any: userId,
            enterable: true,
        }
        : { enterable: true });
    react_1.default.useEffect(() => {
        refetch();
    }, [userId]);
    react_1.default.useEffect(() => {
        if (setTenantId && dropDownItems.length > 0) {
            const newItem = dropDownItems.filter(item => item.id === dropValue.id);
            setTenantId(newItem[0].tenant_id);
        }
        setClasses(dropValue.id);
    }, [dropValue]);
    react_1.default.useEffect(() => {
        if (!data)
            return;
        const default_select = userId ? undefined : { id: 'select', title: 'common.select' };
        const { items, total_count } = data;
        if (total_count > 0) {
            const tenantFilteredItems = isManager && userTenantId !== 'default'
                ? items.filter(item => item.tenant_id === userTenantId)
                : items;
            const activeItems = tenantFilteredItems.filter(item => item.status === 'active');
            setDropDownItems(activeItems);
            setDropList(prevdata => {
                let newList = [];
                default_select && newList.push(default_select);
                const filteredItems = activeItems;
                filteredItems.map((item) => newList.push({
                    id: item.id,
                    title: item.title,
                    tenant_id: item.tenant_id,
                }));
                return newList;
            });
        }
        else {
            default_select && setDropList([]);
        }
    }, [data, userTenantId]);
    (0, react_1.useEffect)(() => {
        if (defaultClasses) {
            const selected = dropList.find(item => item.id === defaultClasses);
            if (selected) {
                setDropValue(selected);
                return;
            }
            if (dropList.length > 0 && dropList[0].id !== 'select') {
                setDropValue(dropList[0]);
            }
        }
    }, [defaultClasses, dropList]);
    return (react_1.default.createElement(common_1.DropDown, { className: userId
            ? `dropdown-home-drop ${isMobile ? 'drop-mobile' : isTablet ? 'drop-tablet' : 'drop-pc'}`
            : 'dropdown-tablet-small', value: dropValue, list: dropList, styles: {
            itemWrap: {
                maxHeight: 200,
                overflow: 'auto',
            },
        }, setDropValue: setDropValue, option: {
            downIcon: {
                size: isTablet ? 30 : 36,
                color: Colors_1.Colors.white,
            },
        } }));
});
